export const PROPERTY_BORDER_COLOR = 'borderColor';
